<div class="project-schedule">
  <div class="schedule-content">
    <!-- Gantt Chart -->
    <div class="gantt-container">
<dx-gantt
        #gantt
        class="gpd-gantt gpd-disable-progress"
        [scaleType]="currentScaleType"
        (onOptionChanged)="onOptionChanged($event)"
        taskTitlePosition="none"
        width="100%"
        height="100%"
        [firstDayOfWeek]="0"
        (onTaskUpdating)="onTaskUpdating($event)"
        (onTaskUpdated)="onTaskUpdated($event)"
        (onDependencyInserted)="onDependencyInserted($event)"
        (onDependencyDeleting)="onDependencyDeleting($event)"
        (onDependencyDeleted)="onDependencyDeleted($event)"
        (onContextMenuPreparing)="onContextMenuPreparing($event)"
        (onTaskMoving)="onTaskMoving($event)"
        taskContentTemplate="taskContentTemplate"
        taskTooltipContentTemplate="taskTooltipContentTemplate"
        taskTimeTooltipContentTemplate="taskTimeTooltipContentTemplate"
        [taskListWidth]="500"
        (onDependencyInserting)="onDependencyInserting($event)"
        [showResources]="false"
        (onTaskEditDialogShowing)="$event.cancel = true"
      >
        <dxo-gantt-context-menu [enabled]="true"></dxo-gantt-context-menu>
        <dxo-toolbar>
          <dxi-item name="zoomIn"></dxi-item>
          <dxi-item name="zoomOut"></dxi-item>
          <dxi-item>
            <div *dxTemplate>
              <app-gpd-button
                i18n-text="@@export"
                type="tertiary"
                text="Export"
                icon="download"
                [disabled]="exportingPdf || ganttTasks.length === 0"
                (onClick)="exportPdf()"
              ></app-gpd-button>
            </div>
          </dxi-item>
          <dxi-item location="after">
            <div *dxTemplate>
              <app-gpd-segmented-switch
                [options]="expandOptions"
                [value]="expandedLevel"
                (valueChange)="setExpandLevel($event)"
              ></app-gpd-segmented-switch>
            </div>
          </dxi-item>
          <dxi-item name="safeMode" *ngIf="isAdmin">
            <div *dxTemplate class="safe-mode-container">
              <dx-check-box
                class="gpd-input"
                i18n-text="@@safeMode"
                text="Safe Mode"
                [(value)]="safeMode"
                (onValueChanged)="onSafeModeChanged($event)"
              ></dx-check-box>
              <app-svg-icon icon="help" color="var(--color-grey-900)" class="help-icon-at" [size]="16"> </app-svg-icon>
              <dx-popover
                target=".help-icon-at"
                showEvent="mouseenter"
                hideEvent="mouseleave"
                [wrapperAttr]="{ class: 'gpd-popover' }"
                position="bottom"
                style="display: none"
              >
                <div class="help-context" i18n="@@safeModeHelp">
                  When enabled, the plan automatically ensures a logical chronological order of connected elements and
                  prevents circular dependencies. If the option is disabled, all elements can be moved freely.
                </div>
              </dx-popover>
            </div>
          </dxi-item>
        </dxo-toolbar>
        <dxi-strip-line [start]="currentDate" title="Now" cssClass="current-time"> </dxi-strip-line>
        <dxo-gantt-scale-type-range max="years" min="days"></dxo-gantt-scale-type-range>
        <dxo-editing
          [enabled]="true"
          [allowDependencyDeleting]="true"
          [allowTaskAdding]="false"
          [allowTaskDeleting]="false"
          [allowResourceAdding]="false"
          [allowResourceDeleting]="false"
          [allowResourceUpdating]="false"
        >
        </dxo-editing>
        <dxo-validation
          [autoUpdateParentTasks]="true"
          [validateDependencies]="safeMode"
          [enablePredecessorGap]="true"
        ></dxo-validation>
        <dxo-tasks
          [dataSource]="displayedGanttTasks"
          keyExpr="id"
          parentIdExpr="parentId"
          endExpr="endDate"
          startExpr="startDate"
          titleExpr="title"
          colorExpr="color"
          progressExpr="progress"
        ></dxo-tasks>
        <dxo-dependencies
          [dataSource]="displayedGanttDependancies"
          keyExpr="id"
          successorIdExpr="taskId"
          typeExpr="dependencyType"
          predecessorIdExpr="dependancyOnId"
        ></dxo-dependencies>

        <dxi-column dataField="sortingIndex" [visible]="false" [sortIndex]="0" sortOrder="asc"></dxi-column>
        <dxi-column dataField="title" i18n-caption="@@title" caption="Title" cellTemplate="titleCellTemplate"></dxi-column>
        <dxi-column dataField="startDate" i18n-caption="@@startDate" caption="Start Date" [width]="120" format="dd.MM.yyyy" cellTemplate="startDateCellTemplate"></dxi-column>
        <dxi-column dataField="endDate" i18n-caption="@@endDate" caption="End Date" [width]="120" format="dd.MM.yyyy" cellTemplate="endDateCellTemplate"></dxi-column>

        <div *dxTemplate="let cell of 'startDateCellTemplate'">
          <div [id]="'gantt-start-' + cell.data.id">
            <dx-date-box
              class="gantt-date-cell"
              [value]="cell.data.startDate"
              displayFormat="dd.MM.yyyy"
              type="date"
              [readOnly]="!isTaskEditable(cell.data.id)"
              [stylingMode]="'underlined'"
              (onValueChanged)="onCellDateChanged(cell.data.id, 'startDate', $event.value)"
            ></dx-date-box>
          </div>
          <dx-tooltip *ngIf="cell.data.itemType === 'Package' && !isTaskEditable(cell.data.id) && packageIdsWithTasks.has(cell.data.itemId)"
            [target]="'#gantt-start-' + cell.data.id"
            showEvent="mouseenter" hideEvent="mouseleave" position="right">
            <div *dxTemplate="let d of 'content'">{{ completedPackageTooltip }}</div>
          </dx-tooltip>
        </div>

        <div *dxTemplate="let cell of 'endDateCellTemplate'">
          <div [id]="'gantt-end-' + cell.data.id">
            <dx-date-box
              class="gantt-date-cell"
              [value]="cell.data.endDate"
              displayFormat="dd.MM.yyyy"
              type="date"
              [readOnly]="!isTaskEditable(cell.data.id)"
              [stylingMode]="'underlined'"
              (onValueChanged)="onCellDateChanged(cell.data.id, 'endDate', $event.value)"
            ></dx-date-box>
          </div>
          <dx-tooltip *ngIf="cell.data.itemType === 'Package' && !isTaskEditable(cell.data.id) && packageIdsWithTasks.has(cell.data.itemId)"
            [target]="'#gantt-end-' + cell.data.id"
            showEvent="mouseenter" hideEvent="mouseleave" position="right">
            <div *dxTemplate="let d of 'content'">{{ completedPackageTooltip }}</div>
          </dx-tooltip>
        </div>

        <div *dxTemplate="let data of 'taskTooltipContentTemplate'">
          <div class="tooltip-content">
            <div class="tooltip-title">{{ data.title }}</div>
            <div class="tooltip-row">
              <span class="row-title" i18n="@@start">Start</span>
              <span class="row-value">
                {{ data.startDate | date: 'dd.MM.yyyy' }}
              </span>
            </div>
            <div class="tooltip-row">
              <span class="row-title" i18n="@@end">End</span>
              <span class="row-value">
                {{ data.endDate | date: 'dd.MM.yyyy' }}
              </span>
            </div>
            <div class="tooltip-row">
              <span class="row-title" i18n="@@duration">Duration</span>
              <span class="row-value"
                >{{ getDuration(data.startDate, data.endDate) }} <span i18n="@@days">days</span></span
              >
            </div>
            <div class="tooltip-row">
              <span class="row-title" i18n="@@progress">Progress</span>
              <span class="row-value">{{ getScheduleProgress(data.id) | number:'1.0-0' }}%</span>
            </div>
          </div>
        </div>

        <div *dxTemplate="let cell of 'titleCellTemplate'" class="gantt-title-cell">
          <a
            *ngIf="cell.data.itemType === 'Package' && packageIdsWithTasks.has(cell.data.itemId); else plainTitle"
            class="gantt-title-text gantt-title-link"
            [attr.href]="getTasksUrl(cell.data.itemId)"
            (click)="onTaskLinkClick($event, cell.data.itemId); $event.stopPropagation()"
            (mousedown)="$event.stopPropagation()"
          >{{ cell.data.title }}</a>
          <ng-template #plainTitle>
            <span class="gantt-title-text">{{ cell.data.title }}</span>
          </ng-template>
        </div>

        <div *dxTemplate="let data of 'taskTimeTooltipContentTemplate'">
          <div class="tooltip-content">
            <div class="tooltip-row">
              <span class="row-title" i18n="@@start">Start</span>
              <span class="row-value">{{ data.start | date: 'dd.MM.yyyy' }} </span>
            </div>
            <div class="tooltip-row">
              <span class="row-title" i18n="@@end">End</span>
              <span class="row-value">
                {{ data.end | date: 'dd.MM.yyyy' }}
              </span>
            </div>

            <div class="tooltip-row">
              <span class="row-title" i18n="@@duration">Duration</span>
              <span class="row-value">{{ getDuration(data.start, data.end) }} <span i18n="@@days">days</span></span>
            </div>
          </div>
        </div>

        <div *dxTemplate="let item of 'taskContentTemplate'">
          <div
            class="schedule-task"
            [style.width.px]="item.taskSize.width"
            [style.height.px]="item.taskSize.height"
            [style.background-color]="item.taskData.color"
          >
            <div
              class="schedule-task-progress"
              [style.width.%]="getScheduleProgress(item.taskData.id)"
              [style.background-color]="taskFillColors.get(item.taskData.id)"
            ></div>
          </div>
        </div>
      </dx-gantt>
    </div>
  </div>

  <div *ngIf="!loading && ganttTasks.length === 0" class="empty-state">
    <span i18n="@@noScheduleData">No schedule data available</span>
  </div>
</div>

<app-validation-toast #toast></app-validation-toast>

<!-- Reopen Schedule Item Reason Popup -->
<app-generic-popup
  [visible]="showReasonPopup"
  i18n-title="@@scheduleChangeReason"
  title="Schedule Change Reason"
  [allowOutsideClick]="false"
  [buttons]="reasonPopupButtons"
>
  <div class="reopen-reason-content">
    <p i18n="@@scheduleChangeReasonDescription">Please select a reason for this schedule change:</p>
    <dx-select-box
      class="gpd-input"
      [(value)]="selectedReopenReasonId"
      [dataSource]="reopenReasons"
      displayExpr="name"
      valueExpr="id"
      [searchEnabled]="true"
    ></dx-select-box>
  </div>
</app-generic-popup>

<app-generic-popup [visible]="showDisableDeps" i18n-title="@@disableDependencies" title="Disable dependencies" [allowOutsideClick]="false" [buttons]="disableDepsButtons">
  <div class="disable-deps-content">
    <p i18n="@@disableDependenciesMessage1">
      If this option is disabled, all items in the schedule can be moved freely. Temporal dependencies are no longer
      checked automatically.
    </p>

    <div class="warning-box">
      <app-svg-icon icon="alert" color="var(--color-task)" class="warning-icon" [size]="20" />
      <div class="warning-content">
        <p i18n="@@disableDependenciesMessage2" style="font-weight: 500">
          This can lead to circular dependencies—i.e., dependencies that contradict each other and no longer allow for a
          clear sequence of events.
        </p>
        <p i18n="@@disableDependenciesMessage3">
          In such cases, the schedule can no longer be processed correctly, which can lead to severely limited
          functionality or unexpected behavior of the system.
        </p>
      </div>
    </div>

    <dx-check-box
      class="gpd-input"
      [(value)]="dontshowAgain"
      (onValueChanged)="onDontShowAgainChanged($event)"
      i18n-text="@@dontShowAgain"
      text="Don't show this message again."
    ></dx-check-box>
  </div>
</app-generic-popup>

<app-generic-popup [visible]="showCircularDepError" i18n-title="@@notAllowed" title="Not allowed" [buttons]="circularDepButtons">
  <div class="circular-dep-content">
    <p i18n="@@circularDependencyError1">
      This action would create a circular dependency and is therefore not allowed.
    </p>
    <p i18n="@@circularDependencyError2">
      An element cannot be linked to
      another element if elements contained within or associated with it are already linked to the same element. Please
      adjust the existing dependencies.
    </p>
    <p i18n="@@circularDependencyError3" style="font-weight: 500;">
      Please adjust the existing dependencies.
    </p>
  </div>
</app-generic-popup>
